export var getFileExtension = function getFileExtension(fileLink) {
  return fileLink === null || fileLink === void 0 ? void 0 : fileLink.split(".").pop();
};